/* eslint-disable */

export enum TranslationType {
  JOURNEY = 0,
  NOWIT_KNOWLEDGE = 1,
  QUERY = 2,
  WIDGET = 3,
  FEEDBACK = 4,
  PUSH_NOTIFICATION = 5,
  UNRECOGNIZED = -1,
}

export interface MachineTranslation {
  title: string;
  description?: string | undefined;
  from?: string | undefined;
  to: string;
  modified?: string | undefined;
  id?: string | undefined;
  type: TranslationType;
}

export interface MachineTranslationResponse {
  item: MachineTranslation | undefined;
}

export interface DetectLanguageRequest {
  text: string;
  language?: string | undefined;
}
